const initialState = {
  redirectTo: false,
};

const reducer = (state = initialState, action) => {
  if (action.type === "REDIRECT") {
    return { redirectTo: action.payload };
  }
  return state;
};

export default reducer;